import { Component } from '@angular/core';
import { DigitalAssetsWrapperComponent } from 'gung-standard';

@Component({
    selector: 'tylo-tylo-digital-assets-wrapper',
    templateUrl: './tylo-digital-assets-wrapper.component.html',
    styleUrls: ['./tylo-digital-assets-wrapper.component.css'],
    standalone: false
})
export class TyloDigitalAssetsWrapperComponent extends DigitalAssetsWrapperComponent {

 
}
